import {
  GET_ALLOW_PROFILE,
  GET_ALLOW_PROFILE_FAILED,
  GET_ALLOW_PROFILE_SUCCESS,
  RESET_TIN,
  SEARCH_TIN,
  SEARCH_TIN_FAILED,
  SEARCH_TIN_SUCCESS,
  VALIDATE_TIN,
  VALIDATE_TIN_FAILED,
  VALIDATE_TIN_SUCCESS,
} from "./constans";

const initialState = {
  allowUpdateProfile: { value: false },
  loading: false,
  validatingTIN: false,
  searchingTin: false,
  searchTinError: false,
  tin: "",
};

export default function profileReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case VALIDATE_TIN:
      return {
        ...state,
        validatingTIN: true,
      };
    case VALIDATE_TIN_SUCCESS:
      return {
        ...state,
        validatingTIN: false,
      };
    case VALIDATE_TIN_FAILED:
      return {
        ...state,
        validatingTIN: false,
      };
    case RESET_TIN:
      return {
        ...state,
        tin: initialState.tin,
        searchingTin: initialState.searchingTin,
        searchTinError: initialState.searchTinError,
      };
    case SEARCH_TIN:
      return {
        ...state,
        searchingTin: true,
        searchTinError: false,
      };
    case SEARCH_TIN_SUCCESS:
      return {
        ...state,
        tin: payload,
        searchingTin: false,
        searchTinError: false,
      };
    case SEARCH_TIN_FAILED:
      return {
        ...state,
        tin: initialState.tin,
        searchingTin: false,
        searchTinError: true,
      };
    case GET_ALLOW_PROFILE:
      return {
        ...state,
        loading: true,
      };
    case GET_ALLOW_PROFILE_SUCCESS:
      return {
        ...state,
        allowUpdateProfile: payload,
        loading: false,
      };
    case GET_ALLOW_PROFILE_FAILED:
      return {
        ...state,
        allowUpdateProfile: { value: false },
        loading: false,
      };

    default:
      return state;
  }
}
